import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/autenticacion/authContext.js';
import '../mercado/mis.css';
import AuthShell, { Aviso, OK_RE } from './AuthShell';
import { useT } from 'i18n';

const ORIGENES = ['Instagram', 'Facebook', 'Email', 'Youtube', 'Google', 'Recomendación', 'Publicidad en Radio/TV', 'Un Amigo/a'];

const NuevaCuenta = (props) => {
  const { t, ts } = useT();
  const { mensaje, registrarUsuario, Limpiar, demo_status } = useContext(AuthContext);
  const [datos, setDatos] = useState({ name: '', email: '', password: '', confirmar: '', referido: '', origen: '' });
  const [ver, setVer] = useState(false);
  const [terminos, setTerminos] = useState(false);
  const [verTerminos, setVerTerminos] = useState(false);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const { name, email, password, confirmar, referido, origen } = datos;

  useEffect(() => { if (mensaje) setEnviando(false); }, [mensaje]);
  useEffect(() => { Limpiar(); return () => Limpiar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const cambiar = (e) => {
    const { name: n, value } = e.target;
    setDatos((d) => ({ ...d, [n]: value }));
    setError('');
    if (mensaje) Limpiar();
  };

  const enviar = (e) => {
    e.preventDefault();
    if (name.trim().split(/\s+/).length < 2) { setError(t('registro.nombreApellido')); return; }
    if (password.length < 6) { setError(t('registro.claveCorta')); return; }
    if (password !== confirmar) { setError(t('registro.clavesNoCoinciden')); return; }
    if (!terminos) { setError(t('registro.aceptaTerminos')); return; }
    setEnviando(true);
    registrarUsuario({ referido, name: name.trim(), email: email.trim(), password, origen });
  };

  const exito = mensaje && OK_RE.test(mensaje) && /confirm|creado/i.test(mensaje);

  if (exito) {
    return (
      <AuthShell ancha demo={demo_status === 'active'}>
        <div className="p7a-estado">
          <div className="p7a-icono ok" aria-hidden="true">✓</div>
          <h2>{t('registro.cuentaCreada')}</h2>
          <p>{t('registro.cuentaCreadaTxt1')}<strong>{email}</strong>{t('registro.cuentaCreadaTxt2')}</p>
          <button type="button" className="p7a-btn" onClick={() => { Limpiar(); props.history.push('/login'); }}>{t('registro.irLogin')}</button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell titulo={t('registro.titulo')} subtitulo={t('registro.subtitulo')} ancha demo={demo_status === 'active'}>
      {mensaje && <Aviso texto={ts(mensaje)} ok={false} />}
      {error && <Aviso texto={error} />}

      <form onSubmit={enviar}>
        <div className="p7a-campo">
          <label htmlFor="name">{t('registro.nombre')}</label>
          <input id="name" name="name" type="text" value={name} onChange={cambiar} required autoComplete="name" />
        </div>
        <div className="p7a-campo">
          <label htmlFor="email">{t('registro.correo')}</label>
          <input id="email" name="email" type="email" placeholder={t('registro.correoEjemplo')} value={email} onChange={cambiar} required autoComplete="email" />
        </div>
        <div className="p7a-campo">
          <label htmlFor="password">{t('registro.clave')}</label>
          <div className="p7a-clave">
            <input id="password" name="password" type={ver ? 'text' : 'password'} value={password} onChange={cambiar} required autoComplete="new-password" minLength={6} />
            <button type="button" onClick={() => setVer(!ver)}>{ver ? t('registro.ocultar') : t('registro.mostrar')}</button>
          </div>
          <span className="p7a-ayuda">{t('registro.claveAyuda')}</span>
        </div>
        <div className="p7a-campo">
          <label htmlFor="confirmar">{t('registro.repite')}</label>
          <input id="confirmar" name="confirmar" type={ver ? 'text' : 'password'} value={confirmar} onChange={cambiar} required autoComplete="new-password" />
        </div>
        <div className="p7a-campo">
          <label htmlFor="origen">{t('registro.origenPregunta')}</label>
          <select id="origen" name="origen" value={origen} onChange={cambiar} required>
            <option value="">{t('registro.origenElige')}</option>
            {ORIGENES.map((o, i) => <option key={o} value={o}>{t('registro.origen' + i)}</option>)}
          </select>
        </div>
        <details className="p7a-det" open={!!referido}>
          <summary>{t('registro.tengoCodigo')}</summary>
          <div className="p7a-campo">
            <input id="referido" name="referido" type="text" placeholder={t('registro.codigo')} value={referido} onChange={cambiar} />
          </div>
        </details>

        <label className="p7a-terminos">
          <input type="checkbox" checked={terminos} onChange={(e) => setTerminos(e.target.checked)} />
          <span>{t('registro.acepto')}<button type="button" onClick={() => setVerTerminos(true)}>{t('registro.terminosLink')}</button></span>
        </label>

        <button type="submit" className="p7a-btn" disabled={enviando}>{enviando ? t('registro.creando') : t('registro.crear')}</button>
      </form>

      <div className="p7a-links">
        <span>{t('registro.yaTienes')} <Link to="/login">{t('registro.iniciar')}</Link></span>
      </div>
      <p className="p7a-nota">{t('registro.nota')}</p>

      {verTerminos && (
        <div className="p7x-overlay p7x-overlay-aviso" role="dialog" aria-modal="true" onClick={() => setVerTerminos(false)}>
          <div className="p7x-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="p7m-cerrar" onClick={() => setVerTerminos(false)} aria-label={t('registro.cerrar')}>×</button>
            <div className="p7a-terms-txt">
<h1>{t('registro.tycTitulo')}</h1>
              <p>{t('registro.tycIntro')}</p>
              <h2>{t('registro.tycGeneralesT')}</h2>
              <p>{t('registro.tycGenerales')}</p>
              <h2>{t('registro.tycDatosT')}</h2>
              <p>{t('registro.tycDatos')}</p>
              <h2>{t('registro.tycRegistroT')}</h2>
              <p>{t('registro.tycRegistro')}</p>
            </div>
            <div className="p7-wallet-actions">
              <button type="button" className="p7-btn-gold" onClick={() => { setTerminos(true); setVerTerminos(false); }}>{t('registro.aceptarBtn')}</button>
            </div>
          </div>
        </div>
      )}
    </AuthShell>
  );
};

export default NuevaCuenta;
